export default __webpack_public_path__ + "static/media/footer-blue-bg.fe0440eb.svg";